import React, { useEffect } from 'react'
import { useRouteError } from 'react-router-dom';
import ErrorLogger from './ErrorLogger';
import ErrorPage from './ErrorPage';
import * as Sentry from "@sentry/react";

export default function ErrorRouteLogger({ children }) {
    const error = useRouteError();

    useEffect(() => {
        if (!error) return;
        Sentry.captureException(error);

        console.error("Route error Boundary caught an error:");
        console.error(error);

        /*logAnalytics("error_caught_route", {
            message: error?.message || "",
            trace: error?.stack || "",
            stack: errorInfo?.componentStack || "-",
            route: this.props.location,
        });*/
    }, [error])

    if (children) {
        return (
            <ErrorLogger>
                <>{children}</>
            </ErrorLogger>
        );
    }
    return (
        <ErrorLogger>
            <ErrorPage />
        </ErrorLogger>
    )
}
